import { TLanguage } from 'config/tenancy';
import { IWebchatSettings } from 'modules/webchat/domain/entities';

import { buildWebchatSettings } from '../helpers';

/**
 * Cada tenância precisa do próprio canal Webchat na Callbell (um idioma por
 * widget). Sem uuid e script_token o chat não carrega e o site mantém o botão
 * flutuante do WhatsApp.
 *
 * Só o Brasil tem Webchat. Paraguai, Costa Rica e Uruguai ficam fixos em null
 * de propósito, e não por variável de ambiente: o pré-chat manda o cliente
 * para /login, rota desabilitada nessas tenâncias, e o login por documento
 * não identifica o cliente no chat. Ligar outra tenância exige esse fluxo de
 * login antes, não só um canal na Callbell.
 */
export const WEBCHAT_SETTINGS: Record<TLanguage, IWebchatSettings | null> = {
  pt: buildWebchatSettings(
    process.env.REACT_APP_CALLBELL_WEBCHAT_UUID,
    process.env.REACT_APP_CALLBELL_WEBCHAT_SCRIPT_TOKEN,
  ),
  es: null,
  'es-CR': null,
  'es-UY': null,
};
